import { isAuthenticated as isAuthenticatedSelector } from "app/pages/Auth/authSelectors";
import { useSelector } from "react-redux";

type WithSearchMyBooking = {
	searchMyBooking?: {
		booking?: {
			bookingReference?: string;
		};
	};
};

export const useAuth = () => {
	const isAuthenticated = useSelector(isAuthenticatedSelector);

	const hasBooking = useSelector((state: WithSearchMyBooking) =>
		Boolean(state.searchMyBooking?.booking?.bookingReference)
	);

	return {
		isAuthenticated,
		hasBooking,
	};
};
